import { useRootStore } from './use-root-store';

export function useUsersStore() {
  return useRootStore().usersStore;
}
